/* src/smoothr-web-app-core/components/payment-modal/payment-modal.component.scss */
ion-spinner {
  margin: 32px;
  height: 72px;
  width: 72px;
}
.payment-input {
  margin: 6px 12px;
  background: var(--payment-modal-item-background, white);
  border-radius: 5px;
  padding: var(--ion-margin);
  color: var(--ion-color-black);
}
.header-msg {
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
}
.payment-method-row {
  min-height: 56px;
  align-items: center;
  margin: 6px 12px;
  background: white;
  border-radius: 5px;
}
.payment-method-row > ion-col {
  padding: 0;
}
.payment-method-row > ion-col ion-item {
  overflow: hidden;
  --background: #00000000;
}
.payment-method-row > ion-col ion-item > ion-radio {
  --color: var(--ion-color-primary);
  --color-checked: var(--ion-color-primary);
  margin: 11px 16px 10px 4px;
}
.payment-method-row > ion-col ion-item > ion-label {
  color: var(--ion-color-black);
  font-weight: bold;
}
.back-icon {
  margin-right: 10px;
  width: 30px;
}
.bottom-end {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 300px;
  width: 142px;
}
.padding-5 {
  padding: 5px;
}
ion-content {
  --background: #F9F9F9;
}
.icon-size {
  margin: 0px;
  zoom: var(--payment-icon-size);
}
/*# sourceMappingURL=payment-modal.component.css.map */
